import { NetworkStatus } from '@apollo/client';
import Raven from 'raven-js';
import { isUngated } from '../utils/isUngated';
import { SCOPES } from '../constants/scopes';
import { useGetInstallabilityQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsRpc.hooks';
import { ReconnectButtonReconnectabilityGate } from '../constants/gates';
import { hasScope } from '../utils/hasScope';
import { useGetOfferingDetails } from './useGetOfferingDetails';
export const useIsReconnectable = args => {
  var _args$skip, _args$listingId, _args$appId, _ref, _installabilityData$i, _installabilityData$i2;
  const skip = (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false;
  const argsListingId = (_args$listingId = args === null || args === void 0 ? void 0 : args.listingId) !== null && _args$listingId !== void 0 ? _args$listingId : 0;
  const appId = (_args$appId = args === null || args === void 0 ? void 0 : args.appId) !== null && _args$appId !== void 0 ? _args$appId : 0;
  const isReconnectabilityUngated = isUngated(ReconnectButtonReconnectabilityGate);
  const {
    data: offering,
    loading: offeringLoading
  } = useGetOfferingDetails({
    appId,
    skip: skip || !!argsListingId || !isReconnectabilityUngated
  });
  const listingId = (_ref = argsListingId || (offering === null || offering === void 0 ? void 0 : offering.listingId)) !== null && _ref !== void 0 ? _ref : 0;
  const {
    data: installabilityData,
    loading: installabilityLoading,
    networkStatus: installabilityNetworkStatus
  } = useGetInstallabilityQuery({
    variables: {
      listingId,
      published: true
    },
    skip: skip || !listingId || offeringLoading || !isReconnectabilityUngated,
    onError: err => {
      Raven.captureException(err, {
        extra: {
          listingId
        }
      });
    }
  });
  const loading = offeringLoading || installabilityLoading;

  /**
   * Case: skip check of scopes and installability intentionally
   */
  if (skip) return {
    isReconnectable: true,
    loading
  };
  const portalInstallable = !!(installabilityData !== null && installabilityData !== void 0 && (_installabilityData$i = installabilityData.installability) !== null && _installabilityData$i !== void 0 && _installabilityData$i.portalInstallable);
  const userInstallable = !!(installabilityData !== null && installabilityData !== void 0 && (_installabilityData$i2 = installabilityData.installability) !== null && _installabilityData$i2 !== void 0 && _installabilityData$i2.userInstallable);
  /**
   * Case: installability data has been received successfully
   */
  if (isReconnectabilityUngated && !!installabilityData && installabilityNetworkStatus === NetworkStatus.ready) {
    return {
      isReconnectable: portalInstallable && userInstallable,
      loading
    };
  }

  /**
   * Fallback: bases on `integrations-management-write` scope access
   */
  const hasScopeAccess = hasScope(SCOPES.INTEGRATIONS_MANAGEMENT_WRITE);
  return {
    isReconnectable: hasScopeAccess,
    loading
  };
};